export const SITE = {
  name: "Wexoz Security & Surveillance LLC",
  short: "WEXOZ",
  tagline: "Transportation Technology Systems Integrator",
  location: "Dubai, United Arab Emirates",
  address: "Sultan Group Investments Building, Hor Al Anz, Deira, Dubai, United Arab Emirates",
  phones: [
    { label: "+971 4 834 2143", tel: "+97148342143" },
    { label: "+971 50 969 3948", tel: "+971509693948" },
  ],
};

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Solutions", path: "/solutions" },
  { name: "Industries", path: "/industries" },
  { name: "Technology", path: "/technology" },
  { name: "About Wexoz", path: "/about" },
  { name: "Insights", path: "/insights" },
  { name: "Contact", path: "/contact" },
];

export const IMAGES = {
  dubai:
    "https://images.unsplash.com/flagged/photo-1559717201-fbb671ff56b7?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000",
  truck:
    "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000",
  truckRoad:
    "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000",
  controlRoom:
    "https://images.unsplash.com/photo-1639313521811-fdfb1c040ddb?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000",
};

export const SOL_IMG = {
  fleet: "/images/solutions/fleet-iot.webp",
  logistics: "/images/solutions/logistics.webp",
  school: "/images/solutions/school.webp",
  cctv: "/images/solutions/cctv.webp",
  ai: "/images/solutions/ai.webp",
  consulting: "/images/solutions/consulting.webp",
};

export const CAPABILITIES = [
  { id: "01", title: "Assess", icon: "Search", text: "Understand the operational requirement and existing technology environment." },
  { id: "02", title: "Design", icon: "PenTool", text: "Architect the right combination of hardware, software, connectivity and platforms." },
  { id: "03", title: "Integrate", icon: "Plug", text: "Connect systems, devices, APIs, sensors, cameras and operational platforms." },
  { id: "04", title: "Deploy", icon: "Rocket", text: "Implement the solution across vehicles, locations and operations." },
  { id: "05", title: "Support", icon: "LifeBuoy", text: "Provide ongoing technology support, monitoring and optimization." },
];

export const SOLUTIONS = [
  {
    slug: "iot-fleet-management",
    title: "IoT Fleet Management",
    short: "Fleet IoT",
    icon: "Satellite",
    tagline: "Connect vehicles, drivers and assets through GPS, telematics, sensors and IoT devices.",
    cta: "Explore Fleet IoT",
    image: SOL_IMG.fleet,
    capabilities: ["GPS tracking", "Vehicle telematics", "Fuel monitoring", "Temperature monitoring", "Driver behavior", "Vehicle diagnostics", "Asset tracking", "Sensor integration", "Geofencing", "Fleet dashboards", "Alerts and notifications"],
    stack: ["GPS", "Telematics", "Sensors", "Fleet Platform"],
  },
  {
    slug: "logistics-automation",
    title: "Logistics Automation",
    short: "Logistics",
    icon: "Route",
    tagline: "Digitize and automate delivery and transportation operations.",
    cta: "Explore Logistics Automation",
    image: SOL_IMG.logistics,
    capabilities: ["Order management", "Dispatch automation", "Route planning", "Driver assignment", "Delivery tracking", "Proof of delivery", "Customer notifications", "Delivery analytics", "API integrations", "ERP / e-commerce integrations"],
    stack: ["Orders", "Dispatch", "Routing", "POD", "APIs"],
  },
  {
    slug: "school-commute-solutions",
    title: "School Commute Solutions",
    short: "School Transport",
    icon: "Bus",
    tagline: "Create safer, more visible and more efficient school transportation operations.",
    cta: "Explore School Transport",
    image: SOL_IMG.school,
    capabilities: ["School bus tracking", "Student boarding / alighting", "RFID / NFC / smart identification", "Parent notifications", "Driver monitoring", "Route monitoring", "Vehicle cameras", "Emergency alerts", "Transport management dashboards", "School administration portal"],
    stack: ["GPS", "RFID / NFC", "Cameras", "Parent App"],
  },
  {
    slug: "transport-cctv-video-intelligence",
    title: "Transport CCTV & Video Intelligence",
    short: "CCTV",
    icon: "Video",
    tagline: "Deploy connected video surveillance across buses, trucks and transportation fleets.",
    cta: "Explore Transport CCTV",
    image: SOL_IMG.cctv,
    capabilities: ["Vehicle CCTV", "MDVR systems", "Live video", "Remote video access", "Driver-facing cameras", "Road-facing cameras", "Passenger monitoring", "Event recording", "AI video analytics", "Harsh-event detection", "Video evidence"],
    stack: ["MDVR", "Cameras", "Live Video", "AI Analytics"],
  },
  {
    slug: "ai-for-transportation",
    title: "AI for Transportation",
    short: "AI",
    icon: "BrainCircuit",
    tagline: "Help transportation organizations apply AI to improve safety, efficiency and operational visibility.",
    cta: "Explore Transportation AI",
    image: SOL_IMG.ai,
    capabilities: ["AI video analytics", "Driver behavior analysis", "Computer vision", "Predictive maintenance", "Anomaly detection", "Fleet performance analytics", "Route intelligence", "Operational intelligence", "AI-powered reporting", "Transportation AI consulting"],
    stack: ["Computer Vision", "Predictive", "Analytics"],
  },
  {
    slug: "transportation-technology-consulting",
    title: "Transportation Technology Consulting",
    short: "Consulting",
    icon: "ClipboardList",
    tagline: "Help organizations select, design and implement the right transportation technology stack.",
    cta: "Talk to a Transportation Technology Expert",
    image: SOL_IMG.consulting,
    capabilities: ["Technology assessment", "Fleet technology consulting", "Solution architecture", "Vendor evaluation", "Hardware selection", "Software selection", "Integration architecture", "Digital transformation", "Transportation technology roadmap"],
    stack: ["Assessment", "Architecture", "Roadmap"],
  },
];

export const AGNOSTIC_STACK = [
  "Fleet management platforms", "Logistics platforms", "IoT devices", "GPS and telematics", "Sensors", "CCTV and MDVR",
  "AI video systems", "Driver applications", "APIs", "ERP systems", "E-commerce platforms", "Custom software",
];

export const ARCHITECTURE_LAYERS = [
  { id: "vehicle", name: "Vehicle Layer", icon: "Truck", items: ["GPS", "Telematics", "CCTV", "Sensors", "MDVR", "Driver devices"] },
  { id: "connectivity", name: "Connectivity Layer", icon: "Wifi", items: ["4G / 5G", "IoT connectivity", "Cloud connectivity"] },
  { id: "intelligence", name: "Intelligence Layer", icon: "BrainCircuit", items: ["Fleet Management", "Logistics Automation", "AI", "Analytics", "Video Intelligence"] },
  { id: "enterprise", name: "Enterprise Layer", icon: "Building2", items: ["ERP", "CRM", "E-commerce", "School Management", "HR / Payroll", "Customer Systems"] },
  { id: "operations", name: "Operations Layer", icon: "MonitorDot", items: ["Control Room", "Fleet Managers", "Dispatchers", "School Administrators", "Operations Teams", "Customers"] },
];

export const INDUSTRIES = [
  { slug: "logistics-delivery", name: "Logistics & Delivery", icon: "Truck", text: "Optimize fleets, dispatch and last-mile operations." },
  { slug: "schools-education", name: "Schools & Education", icon: "GraduationCap", text: "Improve visibility, safety and efficiency across school transportation." },
  { slug: "healthcare", name: "Healthcare", icon: "HeartPulse", text: "Manage time-sensitive transportation and delivery operations." },
  { slug: "retail-ecommerce", name: "Retail & E-commerce", icon: "ShoppingBag", text: "Connect orders, fleets and last-mile delivery." },
  { slug: "corporate-transportation", name: "Corporate Transportation", icon: "Users", text: "Manage employee transportation and commuter fleets." },
  { slug: "passenger-transport", name: "Passenger Transport", icon: "Bus", text: "Improve visibility, safety and operational control." },
  { slug: "government-enterprise", name: "Government & Enterprise", icon: "Landmark", text: "Deploy scalable transportation technology across complex fleets." },
];

export const WHY_WEXOZ = [
  { title: "Technology Agnostic", icon: "Blocks", text: "We select technology based on your requirements." },
  { title: "End-to-End Integration", icon: "Network", text: "Hardware, software, connectivity and systems integrated together." },
  { title: "Transportation Focused", icon: "Truck", text: "We understand real-world fleet and transportation operations." },
  { title: "Enterprise Ready", icon: "ShieldCheck", text: "Solutions designed for scalability, security and reliability." },
  { title: "Local Implementation", icon: "MapPin", text: "Dubai-based implementation, support and customer engagement." },
  { title: "Future Ready", icon: "Sparkles", text: "IoT, AI, automation and connected transportation technologies built into the roadmap." },
];

export const PROCESS = [
  { step: "01", title: "Understand", text: "Understand the business, fleet and operational challenges." },
  { step: "02", title: "Assess", text: "Evaluate existing systems, hardware and processes." },
  { step: "03", title: "Design", text: "Build the appropriate technology architecture." },
  { step: "04", title: "Integrate & Deploy", text: "Implement hardware, software, integrations and connectivity." },
  { step: "05", title: "Optimize", text: "Monitor performance and continuously improve the operation." },
];

export const USE_CASES = [
  { title: "Connected Delivery Fleet", icon: "Truck", stack: ["IoT", "Fleet Management", "Route Optimization", "Proof of Delivery"] },
  { title: "Smart School Bus", icon: "Bus", stack: ["GPS", "CCTV", "Student Identification", "Parent Notifications"] },
  { title: "Intelligent Transport Fleet", icon: "Video", stack: ["GPS", "CCTV", "Driver Monitoring", "AI Video Analytics"] },
  { title: "Temperature-Controlled Logistics", icon: "Thermometer", stack: ["GPS", "Temperature Sensors", "Alerts", "Compliance Reporting"] },
  { title: "Enterprise Transportation", icon: "Building2", stack: ["Fleet Management", "Employee Transport", "Analytics", "Integrations"] },
];

export const TECHNOLOGY = [
  { title: "IoT & Telematics", icon: "Satellite", text: "GPS, telematics devices, sensors and connected assets." },
  { title: "Video & CCTV", icon: "Video", text: "MDVR, IP cameras, mobile cameras and video analytics." },
  { title: "Cloud Platforms", icon: "Cloud", text: "Cloud-based transportation management and operational platforms." },
  { title: "AI", icon: "BrainCircuit", text: "Computer vision, predictive analytics and operational intelligence." },
  { title: "Connectivity", icon: "Wifi", text: "4G, 5G, IoT connectivity and communications." },
  { title: "Integrations", icon: "Plug", text: "REST APIs, ERP, e-commerce, HR, school systems and enterprise applications." },
];

export const SOLUTION_OPTIONS = [
  "Fleet Management", "IoT & Sensors", "Logistics Automation", "School Transport", "Transport CCTV",
  "Transportation AI", "Technology Consulting", "Systems Integration", "Other",
];

export const INDUSTRY_OPTIONS = [
  "Logistics", "Delivery / Courier", "Schools & Education", "Bus & Passenger Transport", "Corporate Transportation",
  "Healthcare", "Retail & E-commerce", "Distribution", "Government / Semi-government", "Other",
];

export const FLEET_SIZES = ["1 – 25 vehicles", "26 – 100 vehicles", "101 – 500 vehicles", "500+ vehicles", "Not applicable"];
